import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

export function useBreakpoint(size: Breakpoint): boolean {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up(size));
}
